import { useRef, RefObject } from 'react';
import { useClickAway, useKey } from 'react-use';

export default function useModalExiting(callback: () => void): RefObject<any> {
  const ref = useRef<any>(null);

  useKey('Escape', callback);

  useClickAway(ref, callback);

  return ref;
}
